import ProductImagesSwiper from './product-images-swiper';

const SingleProduct = () => {
  ProductImagesSwiper();
};

export default SingleProduct;
